import { TableCell, TableRow } from "@mui/material";
import React from "react";
import TablePage from "../../../components/universal/TablePage";
import { RecipesPageHeader } from "./RecipesPageHeader";
import { NotemealRecipeRows } from "./Rows/NotemealRecipeRows";
import { OrgGroupRecipeRows } from "./Rows/OrgGroupRecipeRows";
import { OrgRecipeRows } from "./Rows/OrgRecipeRows";
import { useRecipesPage } from "./useRecipesPage";

export const RecipesPageTable = () => {
  const { paginationHooks, tab, scoringSystem, pageDepsLoading, totalRows, rowsLoading } = useRecipesPage();

  return (
    <TablePage
      header={<RecipesPageHeader />}
      tableHeaderRow={
        <>
          {tab === "org" && (
            <TableRow>
              <TableCell sx={{ width: 150 }}>Shared</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Meal Types</TableCell>
              <TableCell>Yields</TableCell>
              {scoringSystem && <TableCell>Score</TableCell>}
              <TableCell padding="checkbox">Actions</TableCell>
            </TableRow>
          )}
          {tab === "org-group" && (
            <TableRow>
              <TableCell sx={{ width: 150 }}>Shared</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Org Group</TableCell>
              <TableCell>Managed By</TableCell>
              <TableCell>Meal Types</TableCell>
              <TableCell>Yields</TableCell>
              {scoringSystem && <TableCell>Score</TableCell>}
              <TableCell># of Duplications</TableCell>
              <TableCell padding="checkbox">Actions</TableCell>
            </TableRow>
          )}
          {tab === "notemeal" && (
            <TableRow>
              <TableCell sx={{ width: 150 }}>Shared</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Meal Types</TableCell>
              <TableCell>Yields</TableCell>
              <TableCell>Date Added</TableCell>
              <TableCell padding="checkbox">Actions</TableCell>
            </TableRow>
          )}
        </>
      }
      tableBodyRows={
        <>
          {tab === "org" && <OrgRecipeRows />}
          {tab === "org-group" && <OrgGroupRecipeRows />}
          {tab === "notemeal" && <NotemealRecipeRows />}
        </>
      }
      paginationHooks={paginationHooks}
      loading={rowsLoading || pageDepsLoading}
      total={totalRows}
    />
  );
};
